import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin", path: "/admin", title: "Cloud Admin", description: "Adminområde" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Overview /></AdminLayout>,
});
